import User from '@/models/User'
import Avatar from '@/models/Avatar'
import Api from '@/services/api'
import { each, find } from 'lodash'

export default {
  namespaced: true,
  state: {
    list: [],
    listMeta: {
      current_page: 0,
      last_page: 1
    },
    tradieDetails: null
  },

  mutations: {
    setTradieList(state, tradies) {
      each(tradies, tradie => {
        const exist = find(state.list, { id: tradie.id })
        if (!exist) {
          state.list.push(new User(tradie))
        }
      })
    },

    clearTradieList(state) {
      state.list = []
    },

    setTradieListMeta(state, meta) {
      state.listMeta = meta
    },

    setTradieDetails(state, tradie) {
      if (tradie instanceof User) {
        state.tradieDetails = tradie
      } else {
        state.tradieDetails = new User(tradie)
      }
    },

    setSelectedTradieAvatar(state, avatar) {
      if (avatar instanceof Avatar) {
        state.tradieDetails.avatar = avatar
      } else {
        state.tradieDetails.avatar = new Avatar(avatar)
      }
    },

    clearTradieDetails(state) {
      state.tradieDetails = null
    },

    tradieAvatarRemoved(state) {
      state.tradieDetails.avatar = null
    }
  },

  actions: {
    async getTradies({ commit }, params) {
      const query = User.page(params.page || 1)
        .include('avatar')
        .where('user_type', 'tradie')

      if (params.search) {
        query.where('search', params.search)
      }

      if (params.searchDate) {
        query.where('searchDate', params.searchDate)
      }

      if (params.sort) {
        query.orderBy(params.sort)
      }

      const res = await query.params({ limit: 20 }).get()

      commit('setTradieList', res.data)
      commit('setTradieListMeta', res.meta)
    },

    async getTradieDetails({ commit }, id) {
      const { data } = await Api.get(`users/${id}`)
      commit('setTradieDetails', data.data)
    },

    async changeAvatar({ commit }, formData) {
      const { data } = await Api.post(
        `users/${formData.get('user_id')}/avatar`,
        formData
      )
      commit('setSelectedTradieAvatar', data.data)
    },

    async updateTradie({ commit }, formData) {
      const { data } = await Api.put(`users/${formData.id}`, formData)
      commit('setTradieDetails', data.data)
    },

    async blockTradie({ commit }, { id, action }) {
      const { data } = await Api.post(`admin/users/${id}/${action}`)
      commit('setTradieDetails', data.data)
    },

    async exportToExcel() {
      const file = await Api.get('/users/tradie/export', {
        responseType: 'blob'
      })
      return file
    }
  }
}
